<template>
  <div class="sds-hmis-label">
    <div class="badge bg-blue me-1">
      <span v-text="product.blue"></span>
      <span v-if="product.is_chronic">*</span>
    </div>
    <div class="badge bg-red me-1">
      <span v-text="product.red"></span>
    </div>
    <div class="badge bg-orange me-1">
      <span v-text="product.orange"></span>
    </div>
    <div class="badge bg-yellow me-1">
      <span v-text="product.yellow"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SdsHmisLabel",
  props: {
    product: {
      type: Object
    }
  }
};
</script>
